import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { QualificationRequirement } from './types/QualificationRequirement';
import { RequiredDocuments } from './types/RequiredDocuments';

export default (makeCall: MakeCall) =>
  (applyToExistingListing: boolean, data: Array<RequiredDocuments>) =>
    makeCall<QualificationRequirement>(
      'POST',
      `/api/v2/qualification/requirements/defaults`,
      {
        data: {
          applyToExistingListing,
          documents: data,
        },
      },
    );
